<nb-layout [ngClass]="isCatalogPage ? 'layout-fixed-catalog':''">
  <nb-layout-header fixed class="nb-layout-header">

      <ng-container *ngIf="device.isMobile$ | async; else desktopHeader">
          <app-basket-header/>
          <app-header-mobile
                  [sideBarState]="sideBarState"
                  [isShowSearch]="isShowSearch"
                  (toggleSidebarEvent)="toggleSidebar()"
                  (toggleSearchEvent)="toggleSearch()">
          </app-header-mobile>
      </ng-container>

      <ng-template #desktopHeader>
          <div class="top-line" *ngIf="!isShowcase">
              <div class="top-line__left">
                  <div class="top-line__city" (click)="openLocationWindow()">
                      <nb-icon icon="navigation-2-outline"/>
                      <p *ngIf="customerGroup$ | async as customerGroup">{{ customerGroup.header }}</p>
                  </div>
                  <div class="top-line__company" *nbIsGranted="['view','authorized-block']" (click)="openCompanyWindow()">
                      <p i18n="@@Company" *ngIf="contract">{{ contract.counterParty.company }}</p>
                  </div>
              </div>
              <div class="top-line__right">
                  <div class="top-line__contacts">
                      <a class="header-phone-block">
                          Где купить
                      </a>
                      <a class="header-phone-block"
                         [attr.href]="'tel:' + (settings?.phone | slice:0:18)">
                          {{ settings?.phone }}
                      </a>
                      <a class="header-phone-block"
                         [attr.href]="'mailto:' + settings?.mainEmail">
                          {{ settings?.mainEmail }}
                      </a>
                  </div>

                  <mat-menu #menuPhone="matMenu" xPosition="before" class="phone-modal">
                      <h6>
                          {{ translations.schedule }} <br> <small>{{ translations.holidays }}</small>
                      </h6>
                      <p *ngIf="settings">{{ settings.phone }}<br> <a href="mailto:{{ settings.mainEmail }}">{{ settings.mainEmail }}</a></p>
                  </mat-menu>
              </div>
          </div>

          <div class="header-main">
              <div class="header__left">
                  <ng-container *ngIf="!isHomePage">
                      <a class="top-logo" [routerLink]="['/cabinet']"> <img alt="logo" class="logo" src="/assets/images/logo.svg"> <img alt="logo" class="logo-mobile" src="/assets/images/mobile-logo.svg"> </a>
                  </ng-container>
                  <ng-container *ngIf="isHomePage">
                      <a class="top-logo"> <img alt="logo" class="logo" src="/assets/images/logo.svg"> <img alt="logo" class="logo-mobile" src="/assets/images/mobile-logo.svg"> </a>
                  </ng-container>
                  <app-modal-catalog/>
              </div>

              <div class="header-center">
                  <div class="header-center__content">
                      <div *ngIf="isCatalogPage" class="header-filter" (click)="toggleFilter();">
                          <nb-icon icon="funnel-outline"/>
                          <app-filter-count [filter]="productFilter"/>
                      </div>
                      <div class="mob-search" (click)="toggleSearch();">
                          <img class="icon-search" src="/assets/images/header/mob-search.svg" alt="">
                      </div>
                      <div *ngIf="isShowSearch" class="header-search">
                          <app-search-autocomplete/>
                      </div>
                      <div class="header-search">
                          <app-search-autocomplete/>
                      </div>
                  </div>
                  <app-compact-menu
                          *ngIf="(menuItems$ | async)?.length"
                          [items]="menuItems$ | async"
                  />
              </div>

              <div class="header-actions">
                  <ng-container *ngIf="!isShowcase && authService.isAnonymous()">
                      <div class="user-action">
                          <button nbButton status="primary" (click)="open()" i18n="@@Enter">
                              <nb-icon icon="person-outline"/>
                              Войти
                          </button>
                      </div>
                  </ng-container>

                  <ng-container *ngIf="!authService.isAnonymous()">
                      <div class="user-action" nbButton [matMenuTriggerFor]="menu">
                          <nb-icon icon="person-outline"/>
                          <span *ngIf="customer">{{ customer.lastName + ' ' + customer.firstName }}</span>
                      </div>

                      <mat-menu #menu="matMenu" xPosition="before">
                          <p>{{ customer.company }}</p>
                          <ng-container *ngFor="let item of itemsProfile">
                              <button [routerLink]="item.link" mat-menu-item (click)="item?.click()">
                                  {{ item.title }}
                              </button>
                          </ng-container>
                      </mat-menu>
                  </ng-container>

                  <app-basket-header/>

              </div>
          </div></ng-template>
  </nb-layout-header>
    <nb-sidebar #sidebar [state]="sideBarState" *ngIf="!isShowcase">
        <div class="sidebar-inner">

            <div class="mobileMenu" *ngIf="device.isMobile$ | async">
                <div class="mobileMenu__top">
                    <p i18n="@@Menu">Меню</p>
                    <div class="mobileMenu__icon" (click)="toggleSidebar()">
                        <nb-icon icon="close-outline"></nb-icon>
                    </div>
                </div>

                <div class="mobileMenu__info">
                    <div class="mobileMenu__info-item" *ngIf="contract" (click)="openCompanyWindow()">
                        <nb-icon icon="bookmark-outline"/>
                        <span>{{ contract.counterParty.company }}</span>
                    </div>
                    <div class="mobileMenu__info-item" *ngIf="settings?.phone">
                        <nb-icon icon="phone-outline"/>
                        <a href="tel:{{ settings.phone }}">{{ settings.phone }}</a>
                    </div>
                    <div class="mobileMenu__info-item" *ngIf="customerGroup$ | async as customerGroup" (click)="openLocationWindow()">
                        <nb-icon icon="pin-outline"/>
                        <span>{{ customerGroup.header }}</span>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="device.isMobile$ | async">
                <nb-menu *ngIf="(menuItems$ | async)?.length" [items]="menuItems$ | async"/>
            </ng-container>
        </div>
    </nb-sidebar>
  <nb-layout-column>
    <app-breadcrumb separator="›" [hidden]="isHomePage || !(showBreadcrumbs | async)">
      <ng-container *xngBreadcrumbItem="let breadcrumb">
        {{ breadcrumb }}
      </ng-container>
    </app-breadcrumb>

    <div class="center-block center-products" [ngClass]="(isShowFilter && isCatalogPage && !(device.isMobile$ | async)) ? 'checkedFilter' : ''">
      <div class="nb-filter" [hidden]="!isShowFilter || !isCatalogPage || (device.isMobile$ | async)">
        <div class="nb-filter__top">
          <p class="title" i18n="@@Filter">Фильтр товаров</p>
          <nb-icon icon="close" (click)="toggleFilter();" style="cursor: pointer"/>
        </div>
        <app-filter [filter]="productFilter"/>
      </div>
      <div class="center-block__content">
        <router-outlet></router-outlet>
      </div>
    </div>

      <nb-layout-footer *ngIf="!isShowcase && (isMobile$ | async)">
          <app-footer-mobile
                  [isLogged]="accessChecker.isGranted('view', 'authorized-block') | async">
          </app-footer-mobile>
      </nb-layout-footer>

  </nb-layout-column>
</nb-layout>
